import { Component, ViewContainerRef, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ConfigFieldService } from './config_field.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
  selector: 'configure-field',
  templateUrl: './config_field.component.html',
  styleUrls: ['./configSection.css']
})
export class ConfigFieldComponent {
  @ViewChildren('input') vc;


  nameInput = (result: { name: string }) => result.name

  format = (result: { name: string }) => result.name

  searchByData = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 2 ? []
        : this.paySlipIdResults.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10));



  Groups = ["Arun", "Gaurav", "Aman", "Mohit"];
  SelectedGroups = [];
  groupModel = '';
  SelectedgroupModel = '';



  paySlipIdResults = [];
  fieldTypes = [];
  fieldType = "";
  isLengthVisible = false;
  groupSearchDisabled = true;
  isGroupSelected = true;
  data = [];
  fieldId = '';

  groupName = '';
  groupNameSearch: any;
  groupIdentifier = '';
  groupKey = '';
  minLength: number;
  maxLength: number;
  defaultValue = '';

  FieldExist = false;
  SelectedId = '';

  collectionDetails = [];
  searchDataPafing = [];
  indexStart = 0;
  indexEnd = 10;
  pageSize = 4;
  pageNo = 1;
  totalPage = [1];
  buttonType = "Save";
  showEdit = false;
  public originalGroupArray;
  public originalSelectedGroupArray;
  public searchFieldValue;
  public searchSelectedFieldValue;
  showAdd = false

  constructor(
    private conService: ConfigFieldService,
    private router: Router,
    private fb: FormBuilder,
    public toastr: ToastsManager, vcr: ViewContainerRef,
  ) {
    this.originalGroupArray = [];
    this.originalSelectedGroupArray = [];
    this.toastr.setRootViewContainerRef(vcr);
    this.fieldTypes = ["Alphabets", "Numeric", "string", "Date", "Time", "Drop down and master driven", "Auto predictive text and master driven", "Fixed dropdown Values", "Radio button", "Email", "Checkbox", "computated", "Autopopulate"]
    this.conService
      .GetFields()
      .subscribe(collectorObj => {
        this.paySlipIdResults = collectorObj;


        this.collectionDetails = [];
        this.searchDataPafing = [];

        this.collectionDetails = collectorObj;
        if (this.collectionDetails.length > 5) {
          let j = 1;
          for (var i = 0; i < this.collectionDetails.length; i++) {
            i = i + this.pageSize;
            j = j + 1;
            this.totalPage.push(j);
          }
        }
        for (var i = 0; i < this.collectionDetails.length; i++) {
          let arr = [];
          arr = this.collectionDetails[i];
          let rowNum = i;
          this.searchDataPafing.push({ arr, "row": rowNum });
        }
        this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
        this.indexEnd = (this.pageNo * this.pageSize);

      });

    this.conService
      .GetGroups()
      .subscribe(collectorObj => {
        this.Groups = collectorObj;
        this.originalGroupArray = collectorObj;
      });
  }

  pagingAgent(data) {
    this.pageNo = data;
    this.indexStart = (this.pageNo - 1) * this.pageSize + 1;
    this.indexEnd = (this.pageNo) * this.pageSize;
  }

  changeItemsPerPage(data) {
    if (this.collectionDetails.length > 0) {
      this.totalPage = [1]
      let j = 1;
      for (var i = 0; i < this.collectionDetails.length; i++) {
        i = i + this.pageSize;
        j = j + 1;
        this.totalPage.push(j);
      }
    }
    else {
      this.totalPage = [];
    }
    this.pageSize = data;
    this.indexStart = 0;
    this.indexEnd = this.pageSize;
  }

  moveRight() {
    for (var i = 0; i < this.groupModel.length; i++) {
      this.SelectedGroups.push(this.groupModel[i]);
      for (var j = this.Groups.length - 1; j >= 0; j--) {
        if (this.Groups[j] === this.groupModel[i]) {
          this.Groups.splice(j, 1);
        }
      }
    }
    this.groupModel = '';
    if (this.SelectedGroups.length > 0) {
      this.groupSearchDisabled = false;
      this.originalSelectedGroupArray = this.SelectedGroups;
    }
  }

  moveLeft() {
    for (var i = 0; i < this.SelectedgroupModel.length; i++) {
      this.Groups.push(this.SelectedgroupModel[i]);
      for (var j = this.SelectedGroups.length - 1; j >= 0; j--) {
        if (this.SelectedGroups[j] === this.SelectedgroupModel[i]) {
          this.SelectedGroups.splice(j, 1);
        }
      }
    }
    this.SelectedgroupModel = '';
    if (this.SelectedGroups.length > 0) {
      this.groupSearchDisabled = false;
      this.originalSelectedGroupArray = this.SelectedGroups;
    } else {
      this.groupSearchDisabled = true;
    }
  }

  moveAllRight() {
    for (var i = 0; i < this.SelectedGroups.length; i++) {
      this.Groups.push(this.SelectedGroups[i]);
    }
    this.SelectedGroups = this.Groups;
    this.Groups = [];
    if (this.SelectedGroups.length > 0) {
      this.groupSearchDisabled = false;
      this.originalSelectedGroupArray = this.SelectedGroups;
    }
  }

  moveAllLeft() {
    for (var i = 0; i < this.Groups.length; i++) {
      this.SelectedGroups.push(this.SelectedGroups[i]);
    }
    this.Groups = this.SelectedGroups;
    this.SelectedGroups = [];
    if (this.SelectedGroups.length > 0) {
      this.groupSearchDisabled = false;
      this.originalSelectedGroupArray = this.SelectedGroups;
    } else {
      this.groupSearchDisabled = true;
    }
  }

  IsGroupSelected() {
    if (this.SelectedGroups.length > 0) {
      this.isGroupSelected = true;
    }
    else {
      this.isGroupSelected = false;
    }
  }

  selectType(data) {
    if (data == "input") {
      this.isLengthVisible = true;
    }
    else {
      this.isLengthVisible = false;
    }
  }

  onKeyUpMinLength(v) {
    let val = +v;
    if (this.maxLength > 0) {
      if (val > +this.maxLength) {
        this.minLength = this.maxLength - 1;
      }
      else {
        this.minLength = val;
      }
    }
  }

  onKeyUpMaxLength(v) {

    let val = +v;
    if (val < +this.minLength) {
      this.maxLength = +this.minLength + 1;
    }
    else {
      this.maxLength = val;
    }
  }

  ConfigFieldSubmit(configForm) {

    let postSelectedGroups = [];
    for (var i = 0; i < this.SelectedGroups.length; i++) {
      postSelectedGroups.push(this.SelectedGroups[i]["id"]);
    }
    if (this.fieldId == '') {
      if (typeof this.minLength == 'undefined') {
        this.minLength = 0;
      }
      if (typeof this.maxLength == 'undefined') {
        this.maxLength = 0;
      }
      let data = {
        "key": this.camelize(this.groupName),
        "fieldName": this.groupName,
        "isRequired": false,
        "defaultValue": this.defaultValue,
        "className": "col-xs-6",
        "Type": this.fieldType,
        "minLength": +this.minLength,
        "maxLength": +this.maxLength,
        "groupIds": postSelectedGroups,
        "SuperFieldType": ""
      };
      if (this.fieldType == 'file') {
        data = {
          "key": this.camelize(this.groupName),
          "fieldName": this.groupName,
          "isRequired": false,
          "defaultValue": this.defaultValue,
          "className": "col-xs-6",
          "Type": this.fieldType,
          "minLength": +this.minLength,
          "maxLength": +this.maxLength,
          "groupIds": postSelectedGroups,
          "SuperFieldType": "document"
        };
      }
      console.log(data);
      this.conService
        .AddField(data)
        .subscribe(collectorObj => {
          if (collectorObj == 'Success') {
            this.toastr.success('Field added successfully.');
            this.fieldId = '';
            configForm.reset();
            setTimeout(() => {
              this.conService
                .GetFields()
                .subscribe(collectorObj => {
                  this.paySlipIdResults = collectorObj;
                  this.collectionDetails = [];
                  this.searchDataPafing = [];
                  this.collectionDetails = collectorObj;
                  if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                      i = i + this.pageSize;
                      j = j + 1;
                      this.totalPage.push(j);
                    }
                  }
                  for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                  }
                  this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                  this.indexEnd = (this.pageNo * this.pageSize);

                });
            }, 5000);
            this.showAdd = false
            this.showEdit = false
          }
          else {
            this.toastr.error('some error occured.');
          }
          //this.Groups = collectorObj;
        });
    }
    else {
      if (typeof this.minLength == 'undefined') {
        this.minLength = 0;
      }
      if (typeof this.maxLength == 'undefined') {
        this.maxLength = 0;
      }
      let data = {
        "className": "col-xs-6",
        "defaultValue": this.defaultValue,
        "fieldName": this.groupName,
        "groupIds": postSelectedGroups,
        "id": this.fieldId,
        "isRequired": false,
        "key": this.camelize(this.groupIdentifier),
        "maxLength": +this.maxLength,
        "minLength": +this.minLength,
        "Type": this.fieldType,
        "SuperFieldType": ""
      };
      if (this.fieldType == 'file') {
        data = {
          "className": "col-xs-6",
          "defaultValue": this.defaultValue,
          "fieldName": this.groupName,
          "groupIds": postSelectedGroups,
          "id": this.fieldId,
          "isRequired": false,
          "key": this.camelize(this.groupIdentifier),
          "maxLength": +this.maxLength,
          "minLength": +this.minLength,
          "Type": this.fieldType,
          "SuperFieldType": "document"
        };
      }

      this.conService
        .EditField(data)
        .subscribe(collectorObj => {
          if (collectorObj == 'Success') {
            this.toastr.success('Field updates successfully.');
            this.groupNameSearch = ''
            configForm.reset();
            setTimeout(() => {
              this.conService
                .GetFields()
                .subscribe(collectorObj => {
                  this.paySlipIdResults = collectorObj;
                  this.collectionDetails = [];
                  this.searchDataPafing = [];
                  this.collectionDetails = collectorObj;
                  if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                      i = i + this.pageSize;
                      j = j + 1;
                      this.totalPage.push(j);
                    }
                  }
                  for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                  }
                  this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                  this.indexEnd = (this.pageNo * this.pageSize);

                });
            }, 5000);
            this.showAdd = false;
            this.showEdit = false;
          }
          else {
            this.toastr.error('some error occured.');
          }
          //this.Groups = collectorObj;
        });
    }
  }

  selected = (event) => {
    //this.vc.first.nativeElement.focus();
    // this.groupNameBlur(event);
    this.showEdit = true
    this.showAdd = false
    this.buttonType = "Update";
    // console.log(this.groupNameSearch)
    // event.item = this.groupNameSearch
    this.groupIdentifier = this.groupNameSearch.name;
    this.FieldExist = false;


    for (var i = 0; i < this.paySlipIdResults.length; i++) {
      if (this.paySlipIdResults[i]["name"] == this.groupNameSearch.name) {
        this.FieldExist = true;
        this.SelectedId = this.paySlipIdResults[i]["id"];
      }
    }
    if (this.FieldExist) {
      this.conService
        .GetFieldById(this.SelectedId)
        .subscribe(collectorObj => {
          this.defaultValue = collectorObj['defaultValue'];
          this.groupName = collectorObj['fieldName'];
          this.maxLength = collectorObj['maxLength'];
          this.minLength = collectorObj['minLength'];
          this.fieldType = collectorObj['type'];
          this.fieldId = collectorObj["id"];
          this.selectType(this.fieldType);
          for (var i = 0; i < collectorObj["groupIds"].length; i++) {
            for (var j = 0; j < this.Groups.length; j++) {
              if (this.Groups[j]["id"] == collectorObj["groupIds"][i]) {
                this.SelectedGroups.push(this.Groups[j]);
                this.Groups.splice(j, 1);
              }
            }
          }
          if (this.SelectedGroups.length > 0) {
            this.groupSearchDisabled = false;
            this.originalSelectedGroupArray = this.SelectedGroups;
          }
        });
    }

  }

  RowSelected = (event) => {
    //this.vc.first.nativeElement.focus();
    // this.groupNameBlur(event);
    this.groupIdentifier = event;
    //this.FieldExist = false;
    this.buttonType = "Update";
    for (var i = 0; i < this.paySlipIdResults.length; i++) {
      if (this.paySlipIdResults[i]["name"] == event) {
        // this.FieldExist = true;
        this.groupName = this.paySlipIdResults[i];
        this.SelectedId = this.paySlipIdResults[i]["id"];
        setTimeout(() => {    //<<<---    using ()=> syntax
          this.FieldExist = false;
        }, 3000);
      }
    }
    // if (this.FieldExist) {
    this.conService
      .GetFieldById(this.SelectedId)
      .subscribe(collectorObj => {
        this.defaultValue = collectorObj['defaultValue'];
        this.maxLength = collectorObj['maxLength'];
        this.minLength = collectorObj['minLength'];
        this.fieldType = collectorObj['type'];
        this.fieldId = collectorObj["id"];
        this.selectType(this.fieldType);
        for (var i = 0; i < collectorObj["groupIds"].length; i++) {
          for (var j = 0; j < this.Groups.length; j++) {
            if (this.Groups[j]["id"] == collectorObj["groupIds"][i]) {
              this.SelectedGroups.push(this.Groups[j]);
              this.Groups.splice(j, 1);
            }
          }
        }
      });
    // }

  }
  groupNameBlur = (event) => {
    this.groupIdentifier = event.target.value;
  }
  camelize = (str: string) => {
    return str
      .replace(/\s(.)/g, function ($1) { return $1.toUpperCase(); })
      .replace(/\s/g, '')
      .replace(/^(.)/, function ($1) { return $1.toLowerCase(); });
  }
  // groupNameBlur = (event) => {
  //   alert("blur");
  //   this.FieldExist = false;
  //   for (var i = 0; i < this.paySlipIdResults.length; i++) {
  //     if (this.paySlipIdResults[i]["key"] == event.target.value) {
  //       this.FieldExist = true;
  //       this.SelectedId = this.paySlipIdResults[i]["id"];
  //       setTimeout(() => {    //<<<---    using ()=> syntax
  //         this.FieldExist = false;
  //       }, 3000);
  //     }
  //   }
  //   if (this.FieldExist) {
  //     this.conService
  //       .GetFieldById(this.SelectedId)
  //       .subscribe(collectorObj => {
  //         this.defaultValue = collectorObj['defaultValue'];
  //         this.maxLength = collectorObj['maxLength'];
  //         this.minLength = collectorObj['minLength'];
  //         this.fieldType = collectorObj['type'];
  //         this.fieldId = collectorObj["id"];
  //         this.selectType(this.fieldType);
  //         for (var i = 0; i < collectorObj["groupIds"].length; i++) {
  //           for (var j = 0; j < this.Groups.length; j++) {
  //             if (this.Groups[j]["id"] == collectorObj["groupIds"][i]) {
  //               this.SelectedGroups.push(this.Groups[j]);
  //               this.Groups.splice(j, 1);
  //             }
  //           }
  //         }
  //       });
  //   }
  // }
  addNew() {
    this.groupNameSearch = '';
    this.fieldId = '';
    this.groupName = '';
    this.fieldType = '';
    this.defaultValue = '';
    this.isLengthVisible = false;
    this.SelectedGroups = [];
    //this.maxLength =undefined;
    //this.minLength =undefined;
    this.conService
      .GetGroups()
      .subscribe(collectorObj => {
        this.Groups = collectorObj;
      });
    this.showEdit = false
    this.showAdd = true
    this.buttonType = "Save";
  }
  searchGroupFields() {
    let searchData = this.searchFieldValue;
    let searchResult = [];
    this.Groups = this.originalGroupArray;
    if (searchData) {
      for (let i = 0; i < this.Groups.length; i++) {
        if (this.Groups[i]['name'].toLowerCase().indexOf(searchData.toLowerCase()) != -1) {
          searchResult.push(this.Groups[i]);
        }
      }
      this.Groups = [];
      this.Groups = searchResult;
    } else {
      this.Groups = this.originalGroupArray;
    }
  }
  searchSelectedGroupFields() {
    let searchData = this.searchSelectedFieldValue;
    let searchResult = [];
    this.SelectedGroups = this.originalSelectedGroupArray;
    if (searchData) {
      for (let i = 0; i < this.SelectedGroups.length; i++) {
        if (this.SelectedGroups[i]['name'].toLowerCase().indexOf(searchData.toLowerCase()) != -1) {
          searchResult.push(this.SelectedGroups[i]);
        }
      }
      this.SelectedGroups = [];
      this.SelectedGroups = searchResult;
    } else {
      this.SelectedGroups = this.originalSelectedGroupArray;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/config_field/config_field.component.ts